import { useContent } from "contexts/contentContext/contentContext.js";
import GetTransformedDate from "utils/dateViewTransformer.tsx";
import type { DowngradeDetailsT, TransactionT } from "../../models/models";
import { memo } from "react";
import { useSearchParams } from "react-router-dom";

import styles from "./styles.module.scss";

interface TransactionInfoCardI {
  transaction: TransactionT;
  downgradeDetails: DowngradeDetailsT;
}

const TransactionInfoCard = memo(
  ({ transaction, downgradeDetails }: TransactionInfoCardI) => {
    const { getTextByKey } = useContent();
    const [searchParams] = useSearchParams();
    return (
      <div
        className={`${styles.purchaseDetailsContainer} ${
          downgradeDetails ? styles.downgradeCard : ""
        }`}
      >
        {transaction?.PurchaseTransactionInvoiceUrl ? (
          <div className={`${styles.purchaseDetailsLine} ${styles.titleLine}`}>
            <div className={`${styles.purchaseDetailsField} ${styles.title}`}>
              {downgradeDetails
                ? getTextByKey("plan-details-title")
                : getTextByKey("purchase-details-title")}
            </div>
            {!downgradeDetails ? (
              <div className={`${styles.purchaseDetailsValue} ${styles.link}`}>
                <a
                  href={transaction.PurchaseTransactionInvoiceUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  {getTextByKey("purchase-details-receipt")}
                </a>
              </div>
            ) : null}
          </div>
        ) : null}
        {!downgradeDetails &&
        transaction.PurchaseTransactionProviderTransactionId ? (
          <div className={styles.purchaseDetailsLine}>
            <div className={styles.purchaseDetailsField}>
              {getTextByKey("purchase-details-id")}
            </div>
            <div className={styles.purchaseDetailsValue}>
              {transaction.PurchaseTransactionProviderTransactionId}
            </div>
          </div>
        ) : null}
        {!downgradeDetails ? (
          <div className={styles.purchaseDetailsLine}>
            <div className={styles.purchaseDetailsField}>
              {getTextByKey("purchase-item")}
            </div>
            <div className={styles.purchaseDetailsValue}>
              {/* Remove commas from the description */}
              {transaction?.PurchaseTransactionProductDescription?.replace(
                /,/g,
                ""
              )}
            </div>
          </div>
        ) : null}
        <div className={styles.purchaseDetailsLine}>
          <div className={styles.purchaseDetailsField}>
            {downgradeDetails
              ? getTextByKey("next-billing-price")
              : getTextByKey("purchase-details-payment-amount")}
          </div>
          <div className={styles.purchaseDetailsValue}>
            {downgradeDetails
              ? downgradeDetails?.price || 0
              : transaction.PurchaseTransactionAmountDisplay}
          </div>
        </div>
        {(
          downgradeDetails
            ? downgradeDetails.displayName
            : transaction.PurchaseTransactionPaymentType
        ) ? (
          <div className={styles.purchaseDetailsLine}>
            <div className={styles.purchaseDetailsField}>
              {downgradeDetails
                ? getTextByKey("service-plan")
                : getTextByKey("purchase-details-payment-type")}
            </div>
            <div className={styles.purchaseDetailsValue}>
              {getTextByKey(
                downgradeDetails
                  ? downgradeDetails.displayName
                  : transaction.PurchaseTransactionPaymentType
              )}
            </div>
          </div>
        ) : null}
        <div className={styles.purchaseDetailsLine}>
          <div className={styles.purchaseDetailsField}>
            {downgradeDetails
              ? getTextByKey("next-billing-date")
              : getTextByKey("purchase-details-date")}
          </div>
          <div className={styles.purchaseDetailsValue}>
            <GetTransformedDate
              date={
                downgradeDetails
                  ? downgradeDetails.nextBillingDate
                  : transaction.PurchaseTransactionCreationDateDisplay
              }
              fullView
              showDay={false}
            />
          </div>
        </div>
        {/* next payment date */}
        {transaction ? (
          <div className={styles.purchaseDetailsLine}>
            <div className={styles.purchaseDetailsField}>
              {getTextByKey("next-payment-date")}
            </div>
            <div className={styles.purchaseDetailsValue}>
              <GetTransformedDate
                date={transaction?.PurchaseTransactionNextDate}
                fullView
                showDay={false}
              />
            </div>
          </div>
        ) : null}

        {!downgradeDetails ? (
          <div className={styles.purchaseDetailsLine}>
            <div className={styles.purchaseDetailsField}>
              {getTextByKey("purchase-details-full-name")}
            </div>
            <div className={styles.purchaseDetailsValue}>
              {transaction.PurchaseTransactionFullName}
            </div>
          </div>
        ) : null}
        {!downgradeDetails ? (
          <div className={styles.purchaseDetailsLine}>
            <div className={styles.purchaseDetailsField}>
              {getTextByKey("login-user-email-label")}
            </div>
            <div className={styles.purchaseDetailsValue}>
              {transaction.PurchaseTransactionEmail}
            </div>
          </div>
        ) : null}

        {downgradeDetails &&
        (searchParams.get("type") === "sub-users" ||
          searchParams.get("type") === "extra-storage") ? (
          <div className={styles.purchaseDetailsLine}>
            <div className={styles.purchaseDetailsField}>
              {getTextByKey(`downgrade-${searchParams.get("type")}-amount`)}
            </div>
            <div className={styles.purchaseDetailsValue}>
              {downgradeDetails.quantity}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
);

export default TransactionInfoCard;
